export default __webpack_public_path__ + "static/media/box.2ea002e5.jpg";